import React from 'react';
import {connect} from "react-redux";
import {authActions, storeFromArea} from "@mc/mc-legacy";
import {Redirect} from "react-router-dom";
import {Col, Row} from "reactstrap";
import CustomLoginForm from "../components/CustomLoginForm";

class LoginPage extends React.Component {
    static defaultProps = {
        from: "/",
    };
    props: {
        authInfo: {
            data: AuthStatus;
            fetched: boolean;
        };
        from: string;
    };

    render() {
        const {authInfo, logoutStatus} = this.props;

        const {from} = this.props.location.state || {
            from: {
                pathname: "/",
            },
        };

        if (authInfo.data && authInfo.data.auth) {
            return <Redirect to={from}/>;
        }

        return (
            <div className="container">
                <Row className="justify-content-center pt-5">
                    <Col
                        xs="12"
                        sm={{
                            size: 4,
                            offset: 4,
                        }}
                        md={{
                            size: "auto",
                            offset: 0,
                        }}
                    >
                        <h2 className="text-center mb-3">Přihlášení do aplikace QSIGN</h2>
                        <CustomLoginForm skipAutoSso={logoutStatus.data != null && logoutStatus.data.userLogout}/>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default connect((state, props) => ({
    authInfo: storeFromArea(state, authActions.AUTH_INFO_AREA),
    logoutStatus: storeFromArea(state, "logoutStatus"),
}))(LoginPage);
